var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeAbort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1zm-12 5a3 3 0 0 0-3 3v9h1a1 1 0 1 1 0 2H9v11a3 3 0 0 0 3 3h24a3 3 0 0 0 3-3v-2h-1a1 1 0 1 1 0-2h1V13a3 3 0 0 0-3-3h-6.316a1 1 0 1 1 0-2H36a5 5 0 0 1 5 5v18h3a1 1 0 1 1 0 2h-3v2a5 5 0 0 1-5 5H12a5 5 0 0 1-5-5V24H3a1 1 0 1 1 0-2h4v-9a5 5 0 0 1 5-5h6.316a1 1 0 1 1 0 2H12zm5 24a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H17zm19-7a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1zm1-14a1 1 0 1 0-2 0v9a1 1 0 1 0 2 0v-9zm-25-1a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1zM1 19a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H1zm42 16a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1zM25 14a1 1 0 1 0-2 0v13.586l-4.293-4.293a1 1 0 0 0-1.414 1.414l6 6 .707.707.707-.707 6-6a1 1 0 0 0-1.414-1.414L25 27.586V14zm-5 28a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeAbort);
export default __webpack_public_path__ + "static/media/welcome_abort.2d7fd2626434031000f0ef782c9951c6.svg";
export { ForwardRef as ReactComponent };